import {BitmovinPwxAnalyticsPackage} from './adapters/bitmovinPwx/BitmovinPwxAnalyticsPackage';
import {CdnProvider} from './enums/CDNProvider';
import {Player} from './enums/Player';
import {VERSION} from './utils/Version';

export {VERSION as version};

export type {AnalyticsConfig} from './types/AnalyticsConfig';

export {Player as Players};
export {CdnProvider as CdnProviders};

export {BitmovinPwxAnalyticsPackage};
